import React, { useState, useEffect } from 'react';
import Modal from 'antd/lib/modal';
import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import Checkbox from 'antd/lib/checkbox';
import editIcon from '../assets/edit.svg';

import searchIcon from '../../../../../../icons/search.svg';
import searchDarkIcon from '../../../../../../icons/search-dark.svg';

import './MonitoringModal.less';

export const MonitoringModal = (props) => {
  const { Search } = Input;
  const { onCancel, saveChanges, categoryDataPoints, setCategoryDataPoints, theme } = props;
  const [initialDataPoints, setInitialDataPoints] = useState(null);
  const [sortValue, setSortValue] = useState('display_name');
  const [searchValue, setSearchValue] = useState('');
  const [isReversed, setIsReversed] = useState(false);
  const themedSearchIcon = theme === 'dark' ? searchDarkIcon : searchIcon;

  useEffect(() => {
    setInitialDataPoints(categoryDataPoints);
  }, []);

  const handleCheckboxChange = (tag) => {
    const updatedData = categoryDataPoints.map((p) =>
      p.tag === tag ? { ...p, activeCheckbox: !p.activeCheckbox } : p,
    );
    setCategoryDataPoints(updatedData);
  };
  const clearAllPoints = () => {
    setCategoryDataPoints(categoryDataPoints.map((p) => ({ ...p, activeCheckbox: false })));
  };
  const selectAllPoints = () => {
    setCategoryDataPoints(categoryDataPoints.map((p) => ({ ...p, activeCheckbox: true })));
  };

  const updateSortValue = (value) => {
    const reversed = value === sortValue && !isReversed;

    setSortValue(value);
    setIsReversed(reversed);
  };

  const modalColumnClass = 'modal__column-name';

  return (
    <Modal
      className={`monitoring-modal monitoring-modal-${theme}`}
      open
      closable
      keyboard
      maskClosable
      centered
      title="Manage Data Points"
      onCancel={() => {
        onCancel();
        setCategoryDataPoints(initialDataPoints);
      }}
      onOk={() => saveChanges(categoryDataPoints)}
    >
      <div className="modal-content">
        <div className="modal-search">
          <Search
            id="search"
            placeholder="Search Data Points"
            style={{ height: '100%' }}
            onChange={(e) => {
              e.persist();
              setSearchValue(e.target.value);
            }}
            onSearch={(e) => {
              e.persist();
              setSearchValue(e.target.value);
            }}
            prefix={<img src={themedSearchIcon} alt="search icon" />}
          />
        </div>
        <div className="monitoring-details-card__button-wrapper select-buttons">
          <Button
            block
            size="medium"
            className="monitoring-details-card__button"
            style={{ width: 'min-content' }}
            onClick={() => clearAllPoints()}
          >
            <div className="monitoring-details-card__buton-text">
              <img className="edit-img" src={editIcon} alt="edit-icon" />
              Clear all points
            </div>
          </Button>
          <Button
            block
            size="medium"
            className="monitoring-details-card__button"
            style={{ width: 'min-content' }}
            onClick={() => selectAllPoints()}
          >
            <div className="monitoring-details-card__buton-text">
              <img className="edit-img" src={editIcon} alt="edit-icon" />
              Select all points
            </div>
          </Button>
        </div>
        <div className="modal__column-name-wrapper">
          <button
            className={
              sortValue === 'selected'
                ? `${modalColumnClass}-select ${modalColumnClass} modal__column-name--selected`
                : `${modalColumnClass}-select ${modalColumnClass}`
            }
          >
            <span className="modal__column-name-text">Selected</span>
          </button>
          <button
            className={
              sortValue === 'display_name'
                ? `${modalColumnClass} modal__column-name--wide modal__column-name--selected`
                : `${modalColumnClass} modal__column-name--wide`
            }
            onClick={() => updateSortValue('display_name')}
          >
            <span className="modal__column-name-text">
              Data Point
              {!isReversed ? ' ▼' : ' ▲'}
            </span>
          </button>
          <div className={`${modalColumnClass}-status desktop`}>
            <span className="modal__column-name-text">Latest Reading</span>
          </div>
        </div>
        <div className="modal__items">
          {categoryDataPoints
            .sort((a, b) =>
              !isReversed ? a.display_name.localeCompare(b.display_name) : b.display_name.localeCompare(a.display_name),
            )
            .filter((p) => p.display_name.toLowerCase().includes(searchValue.toLowerCase()))
            .map((dataPoint) => {
              const { status, display_name: displayName, tag, activeCheckbox } = dataPoint;
              const dataPointClass = 'modal__column';
              const desktopClass = ' modal__column--desktop ';
              const isSelected = activeCheckbox;
              const selectedItemClass = isSelected
                ? 'modal__registry-item modal__registry-item--selected'
                : 'modal__registry-item';

              return (
                <label htmlFor={tag} key={tag}>
                  <div className={selectedItemClass}>
                    <div className={`${dataPointClass} ${dataPointClass}-select`}>
                      <Checkbox
                        className={`app-checkbox-${theme}`}
                        id={tag}
                        checked={isSelected}
                        onChange={() => handleCheckboxChange(tag)}
                      />
                    </div>
                    <div className={`${dataPointClass} modal__column--wide`}>{displayName}</div>
                    <div className={`${dataPointClass} ${dataPointClass}-status ${desktopClass} desktop`}>{status}</div>
                  </div>
                </label>
              );
            })}
        </div>
      </div>
    </Modal>
  );
};
